export default __webpack_public_path__ + "static/media/explorer.e8c8d0e3.svg";